import React from 'react';
import { Modal, Carousel, Button, Icon } from 'antd';
import { store } from '../../redux/store';

export default class extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showClientModal: false,
      carouselIndex: 0,
    };
    this.carouselRef = React.createRef();
  }

  componentDidMount() {
    store.dispatch({ type: 'RESET_FIRST_TIME_LOGIN' });
    this.setState({ showClientModal: store.getState().Auth.get('firstTimeLogin') });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible !== this.state.visible) {
      this.setState({ showClientModal: nextProps.visible });
    }
  }

  handleCancel = () => {
    this.props.onCancel();
    this.setState({ showClientModal: false });
  };

  showClientModal = () => {
    this.setState({ showClientModal: true });
  };

  gotoRoute = route => {
    window.open(route, '_blank');
  };

  setCarouselIndex = (fromIndex, carouselIndex) => {
    this.setState({ carouselIndex });
  };

  render() {
    const welcomeModalText = () => {
      switch (this.state.carouselIndex) {
        case 0:
          return {
            title: ' Welcome to Resiliens for clinicians',
            description: '',
          };
        case 1:
          return {
            title: 'Set up Profile',
            description: 'Update your profile with all the details relevant to your practice.',
          };
        case 2:
          return {
            title: 'Add Client details',
            description:
              "Add your client details. If your client is already using Swasth's mobile apps, please use the same email address that he/she uses to login to those apps",
          };
        case 3:
          return {
            title: 'Invite Clients to share entries from the app',
            description:
              "You can invite your clients to share their entries from Swasth's mobile apps such as DBT Coach, ACT Coach etc. Navigate to the corresponding app under Apps menu on the left Nav, select the app and client Invite Client button.",
          };
        case 4:
          return {
            title: "View Client's entries (Insights)",
            description:
              "You can get better insight into your Client's activities and progress and thus better engage by having visibility to the Client's entry data from the app. Navigate to 'Clients' on the left menu and click on 'Insights' tab and select the corresponding app.",
          };
        case 5:
          return {
            title: 'Manage Homework Assignments',
            description:
              "You can assign your clients various exercises, practice ideas, lessons etc. as homework. Your clients and submit them all via the mobile apps and you can see them in the 'Insights' screen.",
          };
        case 6:
          return {
            title: 'Assign Standardized Assessments',
            description:
              'You can assign your clients standardized assessments such as PHQ-9, GAD-7 etc. which the clients can submit via the apps.',
          };
        case 7:
          return {
            title: 'Track Client Progress',
            description:
              "You can track your client's progress from standardized assessments using our built-in analytical tools which helps you to better tailor your treatment approach.",
          };

        default:
          return {};
      }
    };

    return (
      <Modal visible={this.state.showClientModal} centered className='welcome_modal' footer={null}>
        <div className='ant-row'>
          <div className='modal_header'>
            <div className='ant-modal-title'>{welcomeModalText().title}</div>
          </div>
          <div className='modal-body'>
            <div className='description-title text-center'>
              <h3>{welcomeModalText().description}</h3>
            </div>
            <div className='navigation-btn-group'>
              <div className='carousel-navigation-slider-btn-left'>
                <Button
                  className='ant-btn ant-btn-primary btn-border-welcome'
                  onClick={() => this.carouselRef.prev()}
                >
                  <Icon type='left' />
                </Button>
              </div>
              <div className='carousel-navigation-slider-btn-right'>
                <Button
                  className='ant-btn ant-btn-primary btn-border-welcome'
                  onClick={() => this.carouselRef.next()}
                >
                  <Icon type='right' />
                </Button>
              </div>
            </div>
            <Carousel
              autoplay
              beforeChange={this.setCarouselIndex}
              ref={node => (this.carouselRef = node)}
            >
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Welcome_Swasth.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/set_profile.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Add_client.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Invite_client.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Client_entries.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Homework_Assign.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Assign_Assessment.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
              <div className='modal-img text-center'>
                <img
                  src='/images/WelcomeModal/Client_track.png'
                  style={{ width: '98%', marginLeft: '1%', marginRight: '1%' }}
                />
              </div>
            </Carousel>
            <div className='footer-modal'>
              <button className='ant-btn btn-help' onClick={() => this.gotoRoute('/help')}>
                Help
              </button>
              <Button onClick={this.handleCancel} style={{ marginRight: 5 }}>
                Skip Tour
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
